import * as React from 'react';
import Modal from '@material-ui/core/Modal';
import { Col, Button, Row, Container } from 'reactstrap';
import AlertModal from '../../../../shared/components/Modal';
import DigitalSignature from '../../../DigitalSignature/DigitalSignature';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileSignature } from "@fortawesome/free-solid-svg-icons";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import InformedConsentNoRefundPDF from './InformedConsentNoRefundPDF';

const InformedConsentNoRefund = ({ data, closeModal, opened }) => {
    const [textInformedConsentNoRefund, setInformedConsentNoRefund] = React.useState(null);
    const [disabledText, setDisabledText] = React.useState(false);
    const [dataPDF, setDataPDF] = React.useState(null);
    const [patientSignature, setPatientSignature] = React.useState(null);
    const [openSignaturePatient, setOpenSignaturePatient] = React.useState(null);
    const [colorAlertModal, setColorAlertModal] = React.useState("");
    const [messagAlerteModal, setMessageAlertModal] = React.useState(null);
    const [showAlertModal, setShowAlertModal] = React.useState(false);
    const [openModalPDF, setOpenModalPDF] = React.useState(null);

    React.useEffect(() => {
        getInformedConsentNoRefund();
    }, []);

    const getTemplatesData = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'historia-plantillas/consultar?id_clinica=' + sessionStorage.getItem('id_clinica'), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            return response.json();
        }).then(dataResponse => {
            console.log("dataResponse",dataResponse);
            if (dataResponse.plantilla.consentimiento_no_reembolso != null) {
                let plantillaConsentimiento = dataResponse.plantilla.consentimiento_no_reembolso.toString();
                let clinica = JSON.parse(sessionStorage.getItem('clinica'));
                let localidad = JSON.parse(sessionStorage.getItem('localidad'));
                let localidadReplace = clinica.direccion.direccion + " - " + localidad.ciudad + "," + localidad.dpto;
                plantillaConsentimiento = plantillaConsentimiento.replace('{paciente}',data.fullname);
                plantillaConsentimiento = plantillaConsentimiento.replace('{procedimiento}',data.servicios[0].nombre);
                plantillaConsentimiento = plantillaConsentimiento.replace('{tipo_identidad}',data.tip_documento);
                plantillaConsentimiento = plantillaConsentimiento.replace('{identidad}',data.num_documento);
                plantillaConsentimiento = plantillaConsentimiento.replace('{empresa}',clinica.nombre);
                plantillaConsentimiento = plantillaConsentimiento.replace('{profesional}',data.nombre_profesional.toUpperCase());
                plantillaConsentimiento = plantillaConsentimiento.replace('{direccion}',localidadReplace);
                setInformedConsentNoRefund(plantillaConsentimiento);
            }
        }).catch(err => {
            console.log(err);
        });
    }

    const getInformedConsentNoRefund = async () => {
        
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'admision-consentimiento-no-reembolso/consultar?id_admision=' + data.id_admision, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error("Ha ocurrido un error cargando el formato de no reembolso, es posible que no se halla diligenciado");
            }
        }).then(data => {
            if (data.consentimiento_no_reembolso != null && data.consentimiento_no_reembolso != undefined) {
                setInformedConsentNoRefund(data.consentimiento_no_reembolso.consentimiento);

                //Recoleccion de Firmas
                let dataConsentimientoInformado = data.consentimiento_no_reembolso;
                dataConsentimientoInformado.firma_paciente = null;

                if (dataConsentimientoInformado.firma_doctor != null && dataConsentimientoInformado.firma_doctor != undefined) {
                    dataConsentimientoInformado.firma_doctor = process.env.REACT_APP_PUBLIC_URL + dataConsentimientoInformado.firma_doctor + "/" + sessionStorage.getItem('token');
                }

                if (dataConsentimientoInformado.firma_tecnologo != null && dataConsentimientoInformado.firma_tecnologo != undefined) {
                    dataConsentimientoInformado.firma_tecnologo = process.env.REACT_APP_PUBLIC_URL + dataConsentimientoInformado.firma_tecnologo + "/" + sessionStorage.getItem('token');
                }

                if (data.consentimiento_no_reembolso.firmas_digitales) {
                    let firmasDigitalesConsentimiento = data.consentimiento_no_reembolso.firmas_digitales.firmas.filter(fir => fir != null);

                    let firmaPaciente = firmasDigitalesConsentimiento.find(fir => fir.autor == "paciente");
                    if (firmaPaciente != undefined && firmaPaciente != null) {
                        let firma = process.env.REACT_APP_PUBLIC_URL + firmaPaciente.url_file_firma + sessionStorage.getItem('token');
                        setPatientSignature(firma);
                        dataConsentimientoInformado.firma_paciente = firma;
                    }
                }

                setDisabledText(true);
                setDataPDF(dataConsentimientoInformado);
            }
            else {
                getTemplatesData();
            }
        }).catch(err => {
            console.log(err);
            getTemplatesData();
        });
        
    }

    const saveInformedConsent = async () => {
        let dataSend = {
            id_admision: data.id_admision,
            html_consentimiento: textInformedConsentNoRefund,
            firma_paciente: patientSignature
        }

        await fetch(process.env.REACT_APP_PUBLIC_URL + 'admision-consentimiento-no-reembolso/create', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error("Ha ocurrido un error en el servidor");
            }
        }).then(data => {
            alertModalOpen("success", "Formato de No Reembolso Generado con exito");
        }).catch(err => {
            console.log(err);
            alertModalOpen("danger", "Ha ocurrido un error generando el Formato de No Reembolso");
        });
    }

    const validateInformedConsent = () => {

        if (textInformedConsentNoRefund == null) {
            alertModalOpen("danger", "No puede generar un formato de No Reembolso sin minimo describirlo");
            return;
        }

        if (patientSignature == null) {
            alertModalOpen("danger", "No puede generar un formato de No Reembolso sin la firma del Paciente");
            return;
        }
        
        alertModalOpen("warning", "Esta seguro que desea generar el Formato de No Reembolso");
    }

    const onOkAlertModal = () => {
        switch (colorAlertModal) {
            case "warning":
                saveInformedConsent();
                break;
            case "success":
                cleanAlertModal();
                closeModal();
                break;
            case "danger":
                cleanAlertModal();
                break;
        }
    }

    const alertModalOpen = (color, message) => {
        setColorAlertModal(color);
        setMessageAlertModal(message);
        setShowAlertModal(true);
    }

    const cleanAlertModal = () => {
        setColorAlertModal("");
        setMessageAlertModal("");
        setShowAlertModal(false);
    }

    const printPDFInformedConsent = () => {
        if (dataPDF != null && dataPDF != undefined) {
            setOpenModalPDF(true);
            InformedConsentNoRefundPDF(dataPDF);
        }
    }

    return (
        <div>
            <Modal
                open={opened}
                onClose={e => {
                    closeModal();
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
                disableEnforceFocus={true}
            >
                <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                    <div>
                        <div className="card__title">
                            <h5 className="bold-text">
                                Formato de No Reembolso
                            </h5>
                        </div>
                        <div style={{ margin: 10, maxHeight: '350px', overflowY: 'scroll' }}>
                            <CKEditor
                                style={{ width: '100%', height: '300px', maxHeight: '300px' }}
                                editor={ClassicEditor}
                                disabled={disabledText}
                                data={textInformedConsentNoRefund}
                                onChange={(event, editor) => {
                                    const data = editor.getData();
                                    setInformedConsentNoRefund(data);
                                }}
                            />
                        </div>
                        <br />
                        <Container>
                            <Row>
                                <Col md={4}>
                                    <div className="text-center">
                                        <Button
                                            style={{ marginTop: 10, marginRight: 10 }}
                                            variant="contained"
                                            color="primary"
                                            className="btn btn-sm"
                                            disabled={disabledText}
                                            onClick={() => {
                                                setOpenSignaturePatient(true);
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faFileSignature} />  Firma del Paciente
                                        </Button>
                                        {
                                            patientSignature != null ? <img style={{ width: 200, height: 60 }} src={patientSignature} /> : null
                                        }
                                        <DigitalSignature
                                            openModalSignature={openSignaturePatient}
                                            closeModalSignature={() => setOpenSignaturePatient(false)}
                                            confirmSign={(value) => {
                                                setPatientSignature(value);
                                            }}
                                            signature={patientSignature}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                        <br />
                        <br />
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 10 }}>
                        <Button
                            className="btn btn-sm"
                            onClick={() => {
                                closeModal();
                            }}
                        >
                            Cerrar
                        </Button>

                        {
                            dataPDF != null ? <Button
                                color="primary"
                                className="btn btn-sm"
                                onClick={() => {
                                    printPDFInformedConsent();
                                }}
                            >
                                Imprimir
                            </Button> : <Button
                                color="primary"
                                disabled={disabledText}
                                className="btn btn-sm"
                                onClick={() => {
                                    validateInformedConsent();
                                }}
                            >
                                Guardar Formato de No Reembolso
                            </Button>
                        }

                    </div>
                </div>
            </Modal >

            <Modal
                open={openModalPDF}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="paperAppointment-flex" style={{ width: '120%', margin: 10 }}>
                    <IconButton style={{ float: 'right' }} onClick={() => {
                        setOpenModalPDF(false);
                    }}>
                        <CloseIcon />
                    </IconButton>
                    <iframe id="pdfV" width="1000" height="600" >

                    </iframe>
                </div>
            </Modal>

            <AlertModal
                color={colorAlertModal}
                title={messagAlerteModal}
                modal={showAlertModal}
                onOk={() => {
                    onOkAlertModal();
                }}
                toggle={() => {
                    cleanAlertModal();
                }}
            />
        </div >
    );
};
export default InformedConsentNoRefund;
